function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNewsRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.01h11v2H8v-2zM8 14.01h11v2H8v-2zM19 18.01H8v2h11v-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 29h18a4 4 0 004-4V7h-5V3H3v22a4 4 0 004 4zm-2-4V5h17v20h2V9h3v16a2 2 0 01-2 2H7a2 2 0 01-2-2z",
    fill: props.color
  }));
}

export default SvgIconNewsRexOutline;